import React from 'react';
import { type AriaDropDownProps } from './common';
import './DropDown.css';

interface DropDownSelectorProps {
  dropDownAria: AriaDropDownProps;
  children: React.ReactNode;
  ariaLabel: string;
  onClick: (e: React.UIEvent) => void;
  onOpenViaKey?: (e: React.KeyboardEvent) => void;
  id: string;
  className?: string;
}

function DropDownSelector({
  dropDownAria,
  children,
  ariaLabel,
  id,
  onClick,
  onOpenViaKey,
  className,
}: DropDownSelectorProps): React.ReactNode {
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === 'ArrowDown') {
      e.preventDefault();
      onOpenViaKey?.(e);
    }
  };

  return (
    <div
      role="combobox"
      className={`${className} drop-down-selector`}
      id={id}
      onClick={onClick}
      onKeyDown={onKeyDown}
      aria-label={ariaLabel}
      aria-controls={dropDownAria.controlsId}
      aria-expanded={dropDownAria.expanded}
      aria-haspopup="listbox"
      aria-activedescendant={dropDownAria.activeDescendantElementId}
      tabIndex={0}
    >
      {children}
    </div>
  );
}

export default DropDownSelector;
